import {
  FieldsConfiguration,
  FormConfiguration,
} from '../typings/configuration';

export const defaultFieldsConfig: FieldsConfiguration = {
  'brand': 'VW',
  'sourceType': 'vw',
  'subType': ' vw_special offers',
  'tag-BrightTagID': '',
  'tag-CampaignID': '',
  'tag-OmnitureID': '',
  'formType': 'lead',
  'formName': '',
  'requestType': '',
  'firstName': '',
  'lastName': '',
  'email': '',
  'phone': '',
  'preferredContactMethod': 'email',
  'comments': '',
  'modelName': '',
  'trim': '',
  'zip': '',
};

export const defaultFormConfiguration: FormConfiguration = {
  formName: 'Contact Dealer',
  title: '**Check your qualification**',
  description:
    'Contact your local dealer to see if you qualify for the Volkswagen Military & First Responder Bonus.',
  CTAlabel: 'Contact your local dealer',
  background: 'linear-gradient(to bottom, #00437a -50%, #001e50 50%)',
  legalDisclaimer:
    'By clicking "Submit request", you agree to Volkswagen’s [Terms of Service](/en/terms.html) and [Privacy Statement](/en/privacy.html). In addition. by clicking "Submit request", you also agree and consent to receive marketing communications regarding Volkswagen products and services from Volkswagen by calling or texting you at the phone number(s) you’ve provided. You understand these calls or text may be made using an automatic telephone dialing system and/or prerecorded message. Your consent to receive calls or texts is not required as a condition of any purchase or lease.',
  submitCTA: 'Submit',
  requestType: 'leads',
  paramsType: 'queryParamsJson',
  formStructure:
    '"model" "firstName" "lastName" "email" "phone" "contactMethod" "zip" "comments"',
  structureColumns: 1,
  hideModelDropdown: false,
  implicitZipCode: false,
};
